import { render } from "./Booster.vue?vue&type=template&id=5b032928"
import script from "./Booster.vue?vue&type=script&lang=js"
export * from "./Booster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__